export const GET_QUESTIONS_REQUEST = 'COURSE_EVALUATION_TEMPLATE_PREVIEW_GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS = 'COURSE_EVALUATION_TEMPLATE_PREVIEW_GET_QUESTIONS_SUCCESS';
export const DISPOSE = 'COURSE_EVALUATION_TEMPLATE_PREVIEW_DISPOSE_STORE';
